import React from 'react'
import { LegacyColor, containerMaxWidth, mq, CTATheme } from '../../utils'
import { Text } from '../../elements/Text'
import { CTALink } from '../../elements/CTALink'
import { NewBrandingHoc } from 'marketing-site/src/library/utils/NewBrandingHoc'
import { NewsUpdatesList as NewsUpdatesListDefault } from './component'

import useFetchNewsUpdates from 'marketing-site/lib/useFetchNewsUpdates'
import useTranslate from '../../hooks/useTranslate'

export function NewsUpdatesListLegacy() {
  const links = useFetchNewsUpdates(10)
  const { translate } = useTranslate()

  return (
    <>
      <div className="news-updates-list--wrapper">
        <h2 className="heading">
          <Text size="xxl">{translate('News & Updates')}</Text>
        </h2>
        <ul className="news-updates-list">
          {links.map((link, index) => {
            return (
              <li key={index} className="list-item">
                <a href={link.url} className="list-item-link">
                  <Text size="body">{link.text}</Text>
                </a>
              </li>
            )
          })}
        </ul>
        <div className="blog-link">
          <CTALink
            url={'https://www.intercom.com/blog'}
            text={'Read more'}
            bgColor={CTATheme.LinkOnlyBlack}
          />
        </div>
      </div>
      <style jsx>
        {`
          .news-updates-list--wrapper {
            display: grid;
            grid-template-columns: [left-gutter] 1fr [content] 12fr [right-gutter] 1fr;
            grid-row-gap: 16px;
          }

          .heading,
          .news-updates-list,
          .blog-link {
            grid-column: content;
            max-width: ${containerMaxWidth};
            width: 100%;
            margin: 0 auto;
          }

          .news-updates-list {
            columns: 2 30ch;
            column-gap: 32px;
          }

          .list-item {
            width: 100%;
            margin: 0;
          }

          .list-item-link {
            display: inline-block;
            padding: 6px 0;
            color: ${LegacyColor.Black};
            text-decoration: none;
          }

          :global(.list-item-link span) {
            border-bottom: 1px solid;
          }

          :global(.list-item-link:hover span) {
            border-bottom: 1px solid;
          }

          @media (${mq.desktopLg}) {
            .news-updates-list--wrapper {
              max-width: ${containerMaxWidth};
              grid-template-columns: [content] 12fr;
              margin: 0 auto;
            }
          }
        `}
      </style>
    </>
  )
}

export const NewsUpdatesList = NewBrandingHoc(NewsUpdatesListLegacy, NewsUpdatesListDefault)
